import CompanyActionsDropdown from "components/company/v2/CompanyActionsDropdown";
import InBookmarksTag from "components/company/v2/InBookmarksTag";
import InPortfolioTag from "components/company/v2/InPortfolioTag";
import CompanyDescription from "components/company/v3/CompanyDescription";
import useBrazilianRealEstateFundIssuer from "components/company/v3/context/hooks/useBrazilianRealEstateFundIssuer";
import FiisExternalLinks from "components/company/v3/realestatefunds/contents/about/FiisExternalLinks";
import Rating from "components/rating/Rating";
import classNames from "components/ui/classNames";
import useSelfie from "lib/hooks/useSelfie";
import { ISecurityCountry } from "types/graphqlTypes";

interface FiisAboutContentProps {
  tickerSymbol: string;
}

export default function FiisAboutContent({ tickerSymbol }: FiisAboutContentProps) {
  const selfie = useSelfie();
  const issuer = useBrazilianRealEstateFundIssuer();

  return (
    <div className="flex w-full flex-col space-y-6 font-aeonik">
      <div className="flex flex-col items-center space-y-3 md:items-start">
        <div className="flex flex-col justify-center gap-3 md:flex-row md:justify-start md:gap-4">
          {issuer.niceLogo && (
            <div className="flex justify-center md:justify-start">
              <img
                role="presentation"
                src={issuer.niceLogo.url}
                width={54}
                height={54}
                alt={issuer.name}
                draggable={false}
                className="select-none object-contain object-right squircle"
              />
            </div>
          )}

          <div className="flex w-full flex-col items-center justify-center gap-3 md:flex-row md:justify-start">
            <h1
              className={classNames(
                "m-0 block overflow-hidden text-ellipsis whitespace-nowrap text-2xl font-bold text-gray-800",
                "max-w-72 sm:max-w-96 md:max-w-xl",
                "dark:text-gray-200",
              )}
            >
              {issuer.name}
            </h1>

            <div className="flex space-x-3">
              {issuer.isFiagro && (
                <div>
                  <span className="rounded-lg bg-green-700 px-2 py-1 text-sm font-bold italic text-white">Fiagro</span>
                </div>
              )}

              {selfie && (
                <CompanyActionsDropdown
                  issuerId={issuer._id}
                  tickerSymbol={tickerSymbol}
                  securityCountry={ISecurityCountry.Br}
                  viewerDidBookmark={issuer.viewerDidBookmark}
                  isInPortfolio={issuer.isInPortfolio}
                />
              )}

              {issuer.isInPortfolio && <InPortfolioTag />}
              {issuer.viewerDidBookmark && <InBookmarksTag />}
            </div>
          </div>
        </div>

        <FiisExternalLinks />
      </div>

      <CompanyDescription tickerSymbol={tickerSymbol} country={ISecurityCountry.Br} />

      {selfie?.isPremium && !selfie?.isTrialing && (
        <Rating
          issuer={issuer}
          rankingPlacement={issuer.overallRankingPlacement}
          rankingRatingSummary={issuer.overallRankingRatingSummary}
        />
      )}
    </div>
  );
}
